import { ApiUrl, AuthorizationHeaders } from '../api/environment';

export default function downloadFile(downloadUrl) {
  return fetch(`${ApiUrl}${downloadUrl}`, {
    method: 'GET',
    headers: AuthorizationHeaders(),
  }).then((res) => {
    const fileName =
      res.headers.get('Content-Disposition')?.split('filename=')[1] ?? 'unnamed.xlsx';
    return res.blob().then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
    });
  });
}
